export function touchStartHandlerDeposit(event, playNgo) {
  var boxDeposit = document.getElementById("box-deposit");
  var header = document.getElementById("panelHeader");
  var limit = playNgo
    ? document.getElementById("fs-wrapper")
    : document.getElementById("fullscr-wrapper");
  limit.bottom = limit.offsetTop + limit.clientHeight - boxDeposit.offsetHeight;
  limit.right = limit.offsetLeft + limit.clientWidth - boxDeposit.offsetWidth;

  let shiftX =
    event.touches[0].clientX - boxDeposit.getBoundingClientRect().left;
  let shiftY =
    event.touches[0].clientY - boxDeposit.getBoundingClientRect().top;

  boxDeposit.style.position = "absolute";
  boxDeposit.style.zIndex = 1003;

  // centers the boxDeposit at (pageX, pageY) coordinates
  function moveAt(pageX, pageY) {
    //var bounding = boxDeposit.getBoundingClientRect();
    var x = pageX - shiftX;
    var y = pageY - shiftY;

    boxDeposit.style.transform =
      "translateX(0px) translateY( " +
      Math.min(limit.bottom, Math.max(limit.offsetTop, y)) +
      "px) translateZ(0)";
    //    console.error("x min " + limit.right + " max " + limit.offsetLeft + " " + pageX);
    //    console.error("y min " + limit.bottom + " max " + limit.offsetTop + " " + y);
  }

  moveAt(event.touches[0].pageX, event.touches[0].pageY);

  function onMouseMove(event) {
    moveAt(event.touches[0].pageX, event.touches[0].pageY);
  }

  // (3) move the boxDeposit on mousemove
  document.addEventListener("touchmove", onMouseMove);
  event.preventDefault();

  // (4) drop the boxDeposit, remove unneeded handlers
  let touchEndtHandler = function () {
    document.removeEventListener("touchmove", onMouseMove);
    event.preventDefault();
    touchEndtHandler = null;
  };
  header.addEventListener("touchend", touchEndtHandler);
}
